module.exports = __webpack_public_path__ + "static/media/boss-attack-boss.e24da8f9.png";